(function () {
  var comboBlocks = document.querySelectorAll('[id*="best_combo_engine_combo_deals"]');
  if (!comboBlocks.length) return;

  comboBlocks.forEach(function (block) {
    function reveal() {
      block.classList.add('combo-block--visible');
      observer.disconnect();
    }

    if (block.querySelector('.bsc-widget')) {
      reveal();
      return;
    }

    var observer = new MutationObserver(function () {
      if (block.querySelector('.bsc-widget')) {
        reveal();
      }
    });
    observer.observe(block, { childList: true, subtree: true });

    // Safety net: stop watching after a reasonable window so we don't
    // listen indefinitely if the app never populates this block.
    setTimeout(function () {
      observer.disconnect();
    }, 6000);
  });
})();
